<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <b-card
          :header="stateOfRequest"
          align="center"
          border-variant="secondary"
          class="mx-auto viewcard"
          header-bg-variant="primary"
          header-border-variant="secondary"
          header-tag="h4"
          header-text-variant="white"
        >
          <b-spinner v-if="isLoading" />
          <b-card-text v-else>
            Ihre Anfrage wurde bisher von
            <span class="font-weight-bolder">{{ viewCount }}</span>
            {{ viewNurses }}
            gesehen.
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "RequestViews",
  data: function() {
    return {
      isLoading: true,
      count: null,
      status: ""
    };
  },
  created() {
    this.$http
      .get("/request/views/" + this.$route.params.code)
      .then(response => {
        this.count = response.data.data["count"];
        this.status = response.data.data["status"];
        switch (this.status) {
          case "open":
            this.status = "offen";
            break;
          case "mediated":
            this.status = "zugeteilt";
            break;
          case "not mediated":
            this.status = "nicht zugeteilt";
            break;
          case "partially assigned":
            this.status = "teilweise zugeteilt";
            break;
          case "archived":
            this.status = "archiviert";
            break;
          default:
            this.status = "unbekannt";
            break;
        }
      })
      .catch(() => this.$router.push("/"))
      .finally(() => (this.isLoading = false));
  },
  computed: {
    viewCount() {
      return this.count === "0" ? "keiner" : this.count;
    },
    viewNurses() {
      return "Hebamme" + (this.count <= 1 ? "" : "n");
    },
    stateOfRequest() {
      return this.isLoading
        ? "Status wird abgerufen"
        : "Status: " + this.status;
    }
  },
  methods: {}
};
</script>

<style scoped>
.viewcard {
  max-width: 40%;
  align-content: flex-end;
}
</style>
